'use strict';

import React, { PropTypes } from 'react';
import ClassNameMixin from './mixins/ClassNameMixin';
import NotificationHost from './hosts/NotificationHost';
import AlertHost from './hosts/AlertHost';
import ModalHost from './hosts/ModalHost';
import OverlayHost from './hosts/OverlayHost';
import SidebarHost from './hosts/SidebarHost';
import PageControlsHost from './hosts/PageControlsHost';
import ContextMenuHost from './hosts/ContextMenuHost';
import DocumentTitle from './atoms/DocumentTitle';
import NavBar from './organisms/NavBar';
import OverlayStore from './stores/OverlayStore';
import createStoreMixin from './mixins/createStoreMixin';
import PureRenderMixin from './mixins/PureRenderMixin';
import IdleScrollMixin from './mixins/IdleScrollMixin';
import RouterStateMixin from './mixins/RouterStateMixin';
import ScreenSizeActionCreators from './actions/ScreenSizeActionCreators';
import StickyPlayerHost from './hosts/StickyPlayerHost';
import { getBrowserName } from './utils/Browser';
import { RouteHandler } from 'react-router';
import StampDraftStore from './stores/StampDraftStore';

const App = React.createClass({
  mixins: [
    ClassNameMixin,
    createStoreMixin(OverlayStore, StampDraftStore),
    RouterStateMixin,
    IdleScrollMixin,
    PureRenderMixin
  ],

  contextTypes: {
    router: PropTypes.func
  },

  getCSSModifiers() {
    return [
      this.isScrolling() && 'scrolling',
      getBrowserName().toLowerCase()
    ];
  },

  getStateFromStores() {
    return {
      shouldDisableScroll: OverlayStore.hasAny() && !OverlayStore.hasContextMenu(),
      hasUnsavedChanges: StampDraftStore.hasUnsavedChanges()
    };
  },

  componentDidMount() {
    this.updateBodyOverflow();
    window.addEventListener('resize', this.handleWindowResize);
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('beforeunload', this.handleBeforeUnload);
  },

  handleBeforeUnload(e) {
    if (this.state.hasUnsavedChanges) {
      var message = 'Changes to your draft have not been saved.';
      (e || window.event).returnValue = message;
      return message;
    }
  },

  componentDidUpdate(prevProps, prevState) {
    if (prevState.shouldDisableScroll !== this.state.shouldDisableScroll) {
      this.updateBodyOverflow();
    }
  },

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowResize);
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('beforeunload', this.handleBeforeUnload);
  },

  updateBodyOverflow() {
    const shouldOverflow = this.state.shouldDisableScroll;
    document.body.style.overflow = shouldOverflow ? 'hidden' : 'auto';
  },

  handleWindowResize() {
    ScreenSizeActionCreators.handleWindowResize();
  },

  getHandlerKey() {
    const childDepth = 1;
    const { router: { getCurrentRoutes, getCurrentParams, getCurrentQuery } } = this.context;
    const childHandler = getCurrentRoutes()[childDepth].handler;
    const params = getCurrentParams();
    const query = getCurrentQuery();

    if (childHandler.getHandlerKey) {
      return childHandler.getHandlerKey(params, query);
    }
  },

  render() {
    return (
      <DocumentTitle>
        <div className={this.getClassName()}>
          <NavBar />
          <RouteHandler {...this.props} key={this.getHandlerKey()} />
          <NotificationHost />
          <OverlayHost />
          <ModalHost />
          <SidebarHost />
          <ContextMenuHost />
          <PageControlsHost />
          <AlertHost />
          <StickyPlayerHost />
        </div>
      </DocumentTitle>
    );
  }
});

export default App;



/** WEBPACK FOOTER **
 ** ./App.jsx
 **/